import {SagaIterator} from 'redux-saga';

import {call, putResolve, select} from 'redux-saga/effects';

import {getShippingMethod} from '../../../reducers/deliveryStep/shippingMethods/shippingMethods';
import {getShippingAddressRegionId} from '../../../selectors/deliveryStep/deliveryStep';
import {getNameSelectedMethod} from '../../../selectors/paymentStep/paymentStep';
import {getShippingAddress} from '../../../selectors/shippingAddress/shippingAddress';
import {addKeysInParams} from '../deliveryStepRootSaga/helper';

/**
 * Get shipping params for methods request
 * @param country
 */
export function* getShippingParamsForMethodsRequestSaga({
    country = '',
    postalCode = '',
} = {}): SagaIterator {
    const shippingAddress = yield select(getShippingAddress);
    const name = yield select(getNameSelectedMethod);
    const regionId = yield select(getShippingAddressRegionId);

    return addKeysInParams({country, name, postalCode, regionId, shippingAddress});
}

/**
 * Getting available shipping methods
 */
export function* getShippingMethodsSaga({country = '', postalCode = ''} = {}): SagaIterator {
    const params = yield call(getShippingParamsForMethodsRequestSaga, {country, postalCode});

    if (!params?.country) return;

    try {
        yield putResolve(getShippingMethod(params));
    } catch (e) {
        console.error(e); // eslint-disable-line no-console
    }
}
